import { useSelector } from 'react-redux'
import React, { useState } from 'react'
import { jt, t } from 'ttag'
import { useParams } from 'react-router-dom'

import {
  loadRiasecResults,
  loadSubsequentRiasecResults
} from '../../actions/assessments/quick'
import { useTitleChange } from '../../util/hooks'
import SearchQueryHandlerComponent from '../../components/search/SearchQueryHandlerComponent'

const QuickAssessmentResults = props => {
  const params = useParams()
  const riasecName = params?.riasec.toUpperCase()
  const pageTitle = t`Quick Assessment :: ${riasecName}`

  useTitleChange(pageTitle)

  const [filterModel, setFilterModel] = useState({})
  const loadFunction = loadRiasecResults(params?.riasec)
  const loadMoreFunction = loadSubsequentRiasecResults(params?.riasec, filterModel)
  const searchRequest = useSelector(state => state.assessments.quickResults)

  return [
    <SearchQueryHandlerComponent
      loadFunction={loadFunction}
      loadMoreFunction={loadMoreFunction}
      setFilterModel={setFilterModel}
      searchRequest={searchRequest}
      {...props}
    />
  ]
}

export default QuickAssessmentResults
